import { type FC } from "react";
import { RatioChart as RatioChartComponent } from "@userFrontend/components/RatioChart";

type Props = {
  ratioData: RatioDataProps;
};

type RatioDataProps = {
  // left
  leftItemRate: number;
  leftItemLabel?: string;
  leftItemBgColor: string;
  leftItemBorderColor?: string;
  // right
  rightItemRate: number;
  rightItemLabel?: string;
  rightItemBgColor: string;
  rightItemBorderColor?: string;
};

export const RatioChart: FC<Props> = ({ ratioData }) => (
  <RatioChartComponent ratioData={ratioData} />
);
